module.exports = __webpack_public_path__ + "static/media/cinema-banner.19906ebd.png";